<template>
<div>
    <img src="@/assets/img/in/banner.png" style="width: 100%;display: block;" alt="" />

    <div class="content">
        <div class="content-item" @click="toLink(item)" v-for="item in dataList" :key="item.article_id">
            <img class="artical-img" :src="item.article_img" alt="">
            <div class="article-info">
                <a :href="`/artical/${item.article_id}`">{{item.article_title}}</a>
                <div class="article-desc" v-html="item.article_content"></div>
                <div class="article-time">{{item.update_time}}</div>
            </div>
        </div>
    </div>

    <div class="pagination-box">
        <pagination @pageTo="pageTo" :totalPage="totalPage"></pagination>
    </div>
</div>
</template>

<script>
    import axios from 'axios';
    import Pagination from '@/components/Pagination';
    export default {
        components:{
            Pagination
        },
        name: "",
        data(){
            return{
                pagination:{
                    page: 1,
                    list_rows: 4
                },
                totalPage: 0,
                dataList:[]
            }
        },
        created(){
            this.getArticalList();
        },
        methods:{
            getArticalList(){
                axios.post("/api/article", this.pagination).then(res => {
                    res = res.data;
                    this.dataList = res.data.rows;
                    this.totalPage = parseInt(res.data.count / this.pagination.list_rows);
                    if (this.totalPage * this.pagination.list_rows != res.data.count) {
                        this.totalPage += 1;
                    }
                })
            },
            toLink(item){
                this.$router.push('/artical/'+item.article_id)
            },
            pageTo(page){
                window.console.log(page)
                this.pagination.page = page;
                this.getArticalList();
            }
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>

    .content{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: .5rem;
        .content-item{
            cursor: pointer;
            width: 15rem;
            height: 3rem;
            background-color: #f9f9f9;
            margin-top: .3rem;
            -webkit-border-radius: .1rem;
            -moz-border-radius: .1rem;
            border-radius: .1rem;
            overflow: hidden;
            display: flex;
            position: relative;
            .artical-img{
                width: 3rem;
                height: 3rem;
                object-fit: contain;
                position: absolute;
                left: 0;
                top: 0;
                background-color: #efefef;
            }
            .article-info{
                display: flex;
                flex-direction: column;
                padding: .3rem;
                padding-left: 3.3rem;
                a{
                    text-decoration: none;
                    font-size: .4rem;
                    font-weight: 600;
                    color: #1d1d1d;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .article-desc{
                    font-size: .28rem;
                    color: #9F9F9F;
                    margin-top: .1rem;
                    margin-bottom: .1rem;
                    height: 1.5rem;
                    overflow: hidden;
                }
                .article-time{
                    font-size: .26rem;
                    color: #9F9F9F;
                }
            }
        }
    }

    .pagination-box{
        width: 15rem;
        margin: 0 auto;
        padding-bottom: 1rem;
    }

    @media screen and (max-width: 800px) {
        .content{
            .content-item{
                width: 7rem;
                height: 2rem;
                .artical-img{
                    width: 2rem;
                    height: 2rem;
                }
                .article-info{
                    padding: .16rem;
                    padding-left: 2.2rem;
                    width: 4.6rem;
                    a{
                        font-size: .3rem;
                    }
                    .article-desc{
                        height: 0.8rem;
                        font-size: .24rem;
                    }
                }
            }
        }
        .pagination-box{
            width: 7rem;
        }
    }

</style>
